import React, { useState } from "react";
import { vendor_page_labels } from "../../../Constants/Labels";
import ImagesPreview from "../../ImagesPreview/ImagesPreview";
import RichTextEditor from "../../Global/RichTextEditor/RichTextEditor";
import "./TextAndImageBlock.css";

const TextAndImageBlock = ({
  data,
  id,
  onRemove,
  textAndImageBlock,
  textAndImageBlockImage,
  onChangeTextAndImageBlockField,
  onChangeTextAndImageBlockDescription,
  onOpenTextAndImageBlockImageSelector,
  onRemoveTextAndImageBlockImage,
  config,
}) => {

  const [localDescription, setLocalDescription] = useState(textAndImageBlock?.left_content?.description || "");
  const [isUserEditing, setIsUserEditing] = useState(false);

  const handleDescriptionChange = (name, value) => {

    console.log("value", id, value);

    setIsUserEditing(true);
    if (value !== localDescription) {
      setLocalDescription(value);
      onChangeTextAndImageBlockDescription(value);
    }
  };

  // console.log("textAndImageBlock",textAndImageBlock, localDescription);

  return (
    <div className="block-container">
      <div className="block-header">
        <h5 className="block-title">
          {vendor_page_labels?.text_and_image_block?.title}
        </h5>
        <div className="block-actions">
          <button className="block-action-btn remove" onClick={onRemove}>
            <span className="mdi mdi-delete"></span> Remove
          </button>
        </div>
      </div>
      <div className="block-content">
        <div className="">
          <div className="card-body">
            <div className="col-12 row">
              <div className="col-6">
                <h6 className="mb-3">
                  {
                    vendor_page_labels?.text_and_image_block?.left_content
                      ?.title
                  }
                </h6>
                <div className="col-12">
                  <div className="form-group">
                    <label className="form-label">
                      {
                        vendor_page_labels?.text_and_image_block?.left_content
                          ?.heading
                      }
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="heading"
                      value={textAndImageBlock?.left_content?.["heading"] || ""}
                      onChange={(e) => onChangeTextAndImageBlockField(e, 'left_content')}
                    />
                  </div>
                </div>
                <div className="col-12 mb-4">
                  <div className="form-group mb-2 page_2_portrait">
                    <label className="form-label">
                      {
                        vendor_page_labels?.text_and_image_block?.left_content
                          ?.description
                      }
                    </label>
                    <RichTextEditor
                      name="description"
                      onChange={handleDescriptionChange}
                      value={localDescription}
                    />
                  </div>
                </div>
                <div className="col-lg-12 row">
                  <div className="form-group col-lg-6">
                    <label className="form-label">
                      {
                        vendor_page_labels?.text_and_image_block?.left_content
                          ?.primary_button_label
                      }
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="primary_button_label"
                      value={textAndImageBlock?.left_content?.["primary_button_label"] || ""}
                      onChange={(e) => onChangeTextAndImageBlockField(e, 'left_content')}
                    />
                  </div>
                  <div className="form-group col-lg-6">
                    <label className="form-label">
                      {
                        vendor_page_labels?.text_and_image_block?.left_content
                          ?.primary_button_url
                      }
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="primary_button_url"
                      value={textAndImageBlock?.left_content?.["primary_button_url"] || ""}
                      onChange={(e) => onChangeTextAndImageBlockField(e, 'left_content')}
                    />
                  </div>
                </div>
                <div className="col-lg-12 row">
                  <div className="form-group col-lg-6">
                    <label className="form-label">
                      {
                        vendor_page_labels?.text_and_image_block?.left_content
                          ?.secondary_button_label
                      }
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="secondary_button_label"
                      value={
                        textAndImageBlock?.left_content?.["secondary_button_label"] || ""
                      }
                      onChange={(e) => onChangeTextAndImageBlockField(e, 'left_content')}
                    />
                  </div>
                  <div className="form-group col-lg-6">
                    <label className="form-label">
                      {
                        vendor_page_labels?.text_and_image_block?.left_content
                          ?.secondary_button_url
                      }
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="secondary_button_url"
                      value={textAndImageBlock?.left_content?.["secondary_button_url"] || ""}
                      onChange={(e) => onChangeTextAndImageBlockField(e, 'left_content')}
                    />
                  </div>
                </div>
                <div className="col-lg-12 row">
                  <div className="form-group col-lg-6">
                    <label className="form-label">
                      Popup Button Label
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="popup_button_label"
                      value={textAndImageBlock?.left_content?.["popup_button_label"] || ""}
                      onChange={(e) => onChangeTextAndImageBlockField(e, 'left_content')}
                    />
                  </div>
                  <div className="form-group col-lg-6">
                    <label className="form-label">
                      Popup Video URL
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="popup_video_url"
                      value={textAndImageBlock?.left_content?.["popup_video_url"] || ""}
                      onChange={(e) => onChangeTextAndImageBlockField(e, 'left_content')}
                    />
                  </div>
                </div>
              </div>
              <div className="col-6">
                <h6 className="mb-3">
                  {
                    vendor_page_labels?.text_and_image_block?.right_image
                      ?.title
                  }
                </h6>
                <div className="col-12">
                  <ImagesPreview
                    acceptMultipleFiles={false}
                    featuredImage={true}
                    savedImages={textAndImageBlockImage}
                    userProfile={false}
                    style={{ width: "90%" }}
                    onOpen={onOpenTextAndImageBlockImageSelector}
                    deleteDisable={true}
                    selectedImageInfo={textAndImageBlockImage}
                    onRemoveImageIds={onRemoveTextAndImageBlockImage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TextAndImageBlock;
